export const plugins = {};

export default function register(name, plugin) {
  if (plugins[name]) {
    throw new Error(`Plugin ${name} already exists`);
  }
  plugins[name] = plugin;
}
